import moment from "moment"
import { DATEFORMAT, DATETIMEFORMAT } from "../constants"

export const formatNumberForDisplay = (number) => {
  // Turns 1001 into 1,001
  if (!number) return ""
  return number.toLocaleString()
}

export const formatDecimalForDisplay = (number, decimalPlaces = 0) => {
  if (!number && number !== 0) return ""
  const formattedNumber = number.toFixed(decimalPlaces || 0).toString()
  return formattedNumber.replace(".0", "") // Don't show .0, just show the whole number
}

export const formatDateForDisplay = (date) => {
  const momentDate = moment(date)
  if (!date || !momentDate.isValid()) return ""
  return momentDate.format(DATEFORMAT)
}

export const formatDateTimeForDisplay = (date) => {
  const momentDate = moment(date)
  if (!date || !momentDate.isValid()) return ""
  return momentDate.format(DATETIMEFORMAT)
}

export const getOrdinalSuffix = (i) => {
  const j = i % 10
  const k = i % 100
  if (j === 1 && k !== 11) {
    return `${i}st`
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`
  }
  return `${i}th`
}



// WEBPACK FOOTER //
// ./src/utils/formatting-utils.js